import React, { useState } from 'react';
import useMobileOS from '../hooks/useMobileOS';
import ReactModal from 'react-modal';
import { CircleX } from 'lucide-react';

function DownloadApp() {
  const os = useMobileOS();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <div
        onClick={() => setIsModalOpen(true)}
        aria-label="Download our mobile app"
        className="whitespace-nowrap cursor-pointer text-[#737376] hover:text-black focus:text-black focus:outline-none focus:ring-2  transition-colors motion-safe:duration-200 hover:underline flex items-center"
      >
        Download app
        <img
          src="/images/mobile-phone1.svg"
          alt="Download app icon"
          width={24}
          height={24}
          className="inline-block ml-1 transition-transform hover:scale-110 motion-safe:duration-200"
          loading="lazy"
        />
      </div>

      <ReactModal
        isOpen={isModalOpen}
        onRequestClose={closeModal}
        overlayClassName="fixed inset-0 bg-[#22222447] bg-opacity-50 flex justify-center items-center z-50"
        className="bg-white p-6 max-w-sm w-[90%] shadow-lg relative text-center"
      >
        <button
          onClick={closeModal}
          className="absolute top-3 right-3 text-white hover:text-black focus:outline-none "
          aria-label="Close modal"
        >
          <CircleX fill="black" color="white" size={24} />
        </button>

        <h2 className="text-lg font-semibold mb-2 text-gray-800">
          Download our app
        </h2>
        <div className="w-[360p] h-[300]"></div>
        <img
          src='/images/download-qr.svg'
          alt="QR code to download app"
          className="mx-auto w-[300px] h-[300px]"
        />
        <p className="text-sm text-gray-500 mt-2">
          Scan this QR code with your phone to download the app.
        </p>
      </ReactModal>
    </>
  );
}

export default DownloadApp;
